const images = {
  VISA: 'logos-tdc-color-visa.svg',
  'VISA DEBITO': 'logos-tdc-color-visa-debito.svg',
  MASTERCARD: 'logos-tdc-color-mastercard.svg',
  'MASTERCARD DEBITO': 'logos-tdc-color-mastercard-debito.svg',
  CABAL: 'logos-tdc-color-cabal.svg',
  'CABAL DEBITO': 'logos-tdc-color-cabal-debito.svg',
  'UNION PAY': 'logos-tdc-color-union-pay.svg',
  'PRISMA FILL': 'logos-prisma-fill.svg',
  MAESTRO: 'logos-tdc-color-maestro.svg',
  AMEX: 'logos-tdc-color-amex.svg',
  'INSTANT PAYMENT': 'logos-tdc-color-pago-instantaneo.svg',
  DISCOVER: 'logos-tdc-color-discover.svg',
  DEFAULT: 'default.svg',
};

export const getImageSrc = key => {
  const imageFileName = images[key] || images['DEFAULT'];
  return '/api/images/' + imageFileName;
};

const logos =  {
  HORIZONTAL: 'logos-horizontal-payway.svg',
  SMALL: 'logos-horizontal-small-payway.svg',
  VERTICAL: 'logos-horizontal-payway.svg',
  DEFAULT: 'logos-horizontal-payway.svg'
}

export const getSiteLogo  = key => {
  const imageFileName = logos[key] || logos['DEFAULT'];
  return '/api/images/' + imageFileName;
};
